import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _3kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"3k_plus"}/>
}
